import React from 'react';

import { FooterContainer, FooterContent, FooterItems } from './styles';

import LogoFooter from '../../assets/logo-footer.svg';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <img alt="Logo" src={LogoFooter} />

        <p>
          Somos um estúdio de desenvolvimento de jogos focado em promover novas
          experiências por meio de jogos atrativos e acessíveis.
        </p>

        <FooterItems>
          <a href="/">POLÍTICA DE PRIVACIDADE</a>
          <a href="/">TERMOS DE SERVIÇO</a>
        </FooterItems>

        <span>copyright 2020 karbonstudio - all rights reserved.</span>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
